export default __webpack_public_path__ + "static/faq-min-868a6285d47b5288f4186cba3a5991e6.jpeg";